import { styled } from '@mui/material/styles';
import { Box, Typography, TableCell, TableRow, Button } from '@mui/material';

// ============================================
// Modal
// ============================================
export const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '640px',
  maxHeight: '80vh',
  backgroundColor: '#fff',
  borderRadius: '10px',
  border: 'none',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
});

export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '20px 24px 16px',
  backgroundColor: '#2D2D2D',
  borderRadius: '10px 10px 0 0',
});

export const ModalTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 700,
  color: '#fff',
});

export const ModalBody = styled(Box)({
  padding: '20px 24px',
  overflowY: 'auto',
  flex: 1,
});

export const ModalFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  padding: '16px 24px',
  borderTop: '1px solid #eee',
});

// ============================================
// Search
// ============================================
export const SearchRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '16px',
});

// ============================================
// Table
// ============================================
export const HeaderCell = styled(TableCell)({
  fontWeight: 600,
  fontSize: '13px',
  color: '#333',
  padding: '10px 8px',
  backgroundColor: '#F0F2F5',
  borderRight: '1px solid #ddd',
  '&:last-child': { borderRight: 'none' },
});

export const BodyRow = styled(TableRow)({
  height: '44px',
  '&:hover': { backgroundColor: '#f9fafb' },
});

export const BodyCell = styled(TableCell)({
  fontSize: '13px',
  color: '#333',
  padding: '8px',
  borderRight: '1px solid #f0f0f0',
  '&:last-child': { borderRight: 'none' },
});

export const EmptyRow = styled(TableCell)({
  padding: '40px 0',
  color: '#999',
  fontSize: '14px',
  textAlign: 'center',
});

export const AddButton = styled(Button)({
  fontSize: '12px',
  fontWeight: 600,
  padding: '4px 12px',
  borderRadius: '6px',
  backgroundColor: '#15AFB7',
  color: '#fff',
  minWidth: 'auto',
  '&:hover': { backgroundColor: '#0F8F95' },
});

export const RemoveButton = styled(Button)({
  fontSize: '12px',
  fontWeight: 600,
  padding: '4px 12px',
  borderRadius: '6px',
  backgroundColor: '#EF4444',
  color: '#fff',
  minWidth: 'auto',
  '&:hover': { backgroundColor: '#DC2626' },
});

// ============================================
// Section Title
// ============================================
export const SectionTitle = styled(Typography)({
  fontSize: '15px',
  fontWeight: 600,
  color: '#333',
  marginBottom: '12px',
});

export const InfoText = styled(Typography)({
  fontSize: '12px',
  color: '#999',
  marginBottom: '16px',
  lineHeight: 1.8,
});
